import {parse,clone,step,key,solved,directions,type Direction,type State} from './engine';
import {levels} from './levels';

export function readProgress(raw:string){
 if(raw.length>150000)throw Error('Save too large');
 const value=JSON.parse(raw);
 if(!value||value.version!==3||!Number.isInteger(value.level)||value.level<0||value.level>=levels.length||!Array.isArray(value.moves)||value.moves.length>10000||value.moves.some((d:unknown)=>!directions.includes(d as Direction))||!Array.isArray(value.completed)||value.completed.length>100)throw Error('Invalid save');
 const b=parse(levels[value.level].rows);let s=clone(b.start);const h:State[]=[];
 for(const d of value.moves as Direction[]){if(solved(b,s))throw Error('Moves after finish');const next=step(b,s,d);if(key(next)===key(s))throw Error('Invalid saved move');h.push(s);s=next;}
 const completed=[...new Set<string>(value.completed.filter((id:unknown)=>levels.some(l=>l.id===id)))];
 return {b,s,h,data:{version:3,level:value.level as number,moves:value.moves as Direction[],completed,lang:value.lang===1?1 as const:0 as const}};
}

export function transferredProgress(hash:string){
 if(!hash.startsWith('#minterra-save='))return null;
 if(hash.length>450000)throw Error('Transfer too large');
 return readProgress(decodeURIComponent(hash.slice('#minterra-save='.length)));
}
